import store from '@/store/store';
import set from 'lodash/set';
import genererCampagneObjet from '@/services/bodac/campagne/genererCampagne';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';

function getParametreIdFromStore(nom, value) {
  return store.getters['parametres/parametre'](PARAMETRES_KEYS[nom])?.find((param) => {
    return param.libelle.toLowerCase().trim() === value?.toLowerCase()?.trim();
  })?.id ?? null;
}

export function fillCampagneWithData(campagne, ligne, marques) {
  const errors = [];
  const banColumnAuto = ['marqueId'];
  const boolColumn = ['newsLetter', 'visibleParLaMarque'];
  const keys = Object.keys(ligne);

  // fait tout les columns facile
  for (let i = 0; i < keys.length; i += 1) {
    if (!banColumnAuto.includes(keys[i])) {
      if (boolColumn.includes(keys[i])) {
        set(campagne, keys[i], booleanConverter(ligne[keys[i]]));
      } else if (keys[i].startsWith('date')) {
        set(campagne, keys[i], formatDate(moment(ligne[keys[i]], 'DD/MM/YYYY')));
      } else {
        set(campagne, keys[i], ligne[keys[i]]);
      }
    }
  }
  const marque = marques.find(m => m.libelle.toLowerCase() === ligne.marqueId.toLowerCase());
  campagne.marqueId = marque.id;
  campagne.tags = campagne.tags
    ? campagne.tags.map(t => ({ tagId: getParametreIdFromStore('tag', t) }))
    : [];
  if (errors.length > 0) throw errors;
  return campagne;
}

export default function genererCampagne(ligne, marques) {
  const campagne = genererCampagneObjet(store.getters['societe/societeActiveId']);
  return fillCampagneWithData(campagne, ligne, marques);
}
